import React, { useEffect, useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const ProgressBar = ({ label, percentage }) => {
  const [width, setWidth] = useState(0);
  const progressBarRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setWidth(percentage);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (progressBarRef.current) {
      observer.observe(progressBarRef.current);
    }

    return () => observer.disconnect();
  }, [percentage]);
  return (
    <div ref={progressBarRef} className="w-full mb-2 md:mb-4">
      <div className="flex justify-between mb-1">
        <span className="text-xs md:text-sm font-medium text-white">{label}</span>
        <span className="text-xs font-medium text-white">{percentage}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1.5 md:h-2.5 dark:bg-gray-700">
        <div
          className="bg-secondary  h-1.5 md:h-2.5 rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${width}%` }}
        ></div>
      </div>
    </div>
  );
};

const CertificateCaraousel = ({ Certifications }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <Carousel responsive={responsive} autoPlay infinite
    >
      {Certifications.map((certificate, index) => (
        <div
          key={index}
          onClick={() => window.open(certificate.url, "_blank")}
          className="cursor-pointer p-4 md:hover:scale-110 transofrm transition duration-300"
        >
          <img
            src={certificate.img}
            alt={`Certificate ${index + 1}`}
            className="object-contain mx-auto h-40 w-60"
          />
        </div>
      ))}
    </Carousel>
  );

};

export default function SkillsAndCertifications() {
  const skills = [
    { label: "C++", percentage: 80 },
    { label: "Python", percentage: 60 },
    { label: "HTML", percentage: 95 },
    { label: "CSS", percentage: 90 },
    { label: "Tailwind CSS", percentage: 80 },
    { label: "JavaScript", percentage: 90 },
    { label: "React (Js & Native)", percentage: 80 },
    { label: "Node.js", percentage: 70 },
    { label: "Express.js", percentage: 70 },
    { label: "MongoDB", percentage: 70 },
    { label: "MySQL", percentage: 80 },
    { label: "Spring Boot", percentage: 70 },
  ];

  const Certifications = [
    {
      url: "https://certificate.codingninjas.com/verify/4792f94df340d9d6",
      img: require("../assets/images/certificates/DSA.png"),
    },
    {
      url: "https://certificate.codingninjas.com/verify/80ec17a3b8f3f9c7",
      img: require("../assets/images/certificates/DSAExcellence.png"),
    },
    {
      url: "https://www.coursera.org/account/accomplishments/verify/MT8H9QDCF49C",
      img: require("../assets/images/certificates/SupervisedML.png"),
    },
    {
      url: "https://www.udemy.com/certificate/UC-dbeb48a5-0f69-4c7a-a5a4-3aaa4d6ddb45/",
      img: "https://udemy-certificate.s3.amazonaws.com/image/UC-dbeb48a5-0f69-4c7a-a5a4-3aaa4d6ddb45.jpg"
    },
    {
      url: "https://www.udemy.com/certificate/UC-cd2508b9-52b9-4778-9f84-cdff36c12c42/",
      img: "https://udemy-certificate.s3.amazonaws.com/image/UC-cd2508b9-52b9-4778-9f84-cdff36c12c42.jpg",
    },
   
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div id="skills-certifications" className="px-10 md:px-20 py-5 md:py-10">
      <h2 className="text-2xl md:text-4xl font-bold text-left md:text-center  md:mb-10">
        My <span className="text-secondary"> Skills</span> and{" "}
        <span className="text-secondary"> Certifications</span>
      </h2>

      {/* skills */}
      <div className="md:my-10">
        <h3 className="text-lg md:text-2xl font-semibold my-5 md:my-10">Skills</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          {skills.map(({ label, percentage }, index) => (
            <ProgressBar key={index} label={label} percentage={percentage} />
          ))}
        </div>
      </div>

      {/* Certifications */}

      <div className="my-5 md:my-10">
        <h3 className="text-lg md:text-2xl font-semibold mt-10 mb-5">Certifications</h3>
        <CertificateCaraousel Certifications={Certifications} />
      </div>
    </div>
  );
}
